import { render } from "./Forum-select-item.vue?vue&type=template&id=0e79a91d&scoped=true&lang=pug"
import script from "./Forum-select-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum-select-item.vue?vue&type=script&setup=true&lang=js"

import "./Forum-select-item.vue?vue&type=style&index=0&id=0e79a91d&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e79a91d"]])

export default __exports__